import { required, yup } from "./CommonValidation";
import * as Yup from 'yup';
export const OurTeamSchema = (type) => { 
    if (type === 'add') {
        return yup({
            name: required("Please enter name"),
            designation: required("Please enter designation")
            // url: required("Please enter social media link url").url()
        });
    } 
};